import { render } from "./PageListarProfissionalAgendar.vue?vue&type=template&id=1673e3ee"
import script from "./PageListarProfissionalAgendar.vue?vue&type=script&lang=js"
export * from "./PageListarProfissionalAgendar.vue?vue&type=script&lang=js"

import "./PageListarProfissionalAgendar.vue?vue&type=style&index=0&id=1673e3ee&lang=css"
/* custom blocks */
import block0 from "./PageListarProfissionalAgendar.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__